import WithLayout from "src/Components/Layout/Layout";
import ApplicativeServersManagement from "./ApplicativeServersManagement";

export default WithLayout(ApplicativeServersManagement);